import React from 'react';
import { Outlet } from 'react-router-dom';

import SessionContextProvider from '../../../shared/SessionContext';
import l10n from '../l10n';
import Header from './Header';

function Layout() {
  return (
    <SessionContextProvider market="unk" l10n={l10n}>
      <Header />
      <Outlet />
    </SessionContextProvider>
  );
}

export default Layout;
